/* eslint-disable @typescript-eslint/no-unused-vars */
import { useFormContext } from "components/Form";
import { useEffect, useMemo, useState } from "react";
import {
  ResultResponse,
  simulatorFinanceService,
} from "services/simulatorFinanceService";
import { SimulateFinanceData } from "..";
import { formatValueCurrency } from "utils/formatValueCurrency";
import { DetailsResultSac } from "./Result";
import { DetailsResultPrice } from "pages/SimulatorCredit/ResultCredit/Result";

export function ResultFinance() {
  const [result, setResult] = useState<ResultResponse | undefined>(undefined);
  const [amortization, setAmortization] = useState<string>("Sistema SAC");

  const {
    methodsForm: { getValues },
  } = useFormContext();

  useEffect(() => {
    const values = getValues();

    const data = {
      city: values.city.value,
      deadline: values.deadline.value?.replace("meses", "").trim(),
      approximateAmount: formatValueCurrency(values.approximateAmount),
      countMonths: values.countMonths,
      cpf: values.cpf,
      dateBirthday: values.dateBirthday,
      email: values.email,
      financingAmount: formatValueCurrency(values.financingAmount),
      name: values.name,
      phoneNumber: values.phoneNumber,
      propertyType: values.propertyType,
      amortizationType: values.amortizationType,
    } as SimulateFinanceData;

    setAmortization(data.amortizationType);

    let response;
    if (data.amortizationType === "Sistema SAC") {
      response = simulatorFinanceService.simulateSac(data);
    } else {
      response = simulatorFinanceService.simulatePrice(data);
    }

    response.then(({ data }) => {
      setResult(data.data);
    });
  }, [getValues]);

  const approximateAmountFormated = useMemo(() => {
    const value = getValues("approximateAmount");

    return new Intl.NumberFormat("pt-br", {
      style: "currency",
      currency: "BRL",
    }).format(Number(value / 100));
  }, [getValues]);

  const financingAmountFormated = useMemo(() => {
    const value = getValues("financingAmount");

    return new Intl.NumberFormat("pt-br", {
      style: "currency",
      currency: "BRL",
    }).format(Number(value / 100));
  }, [getValues]);

  return amortization !== "Sistema SAC" ? (
    <DetailsResultPrice
      result={result}
      creditAmountFormated={financingAmountFormated}
      propertyAmountFormated={approximateAmountFormated}
    />
  ) : (
    <DetailsResultSac
      result={result}
      financingAmountFormated={financingAmountFormated}
    />
  );
}
